import { render, staticRenderFns } from "./producer_footer.vue?vue&type=template&id=59658f04&scoped=true"
import script from "./producer_footer.vue?vue&type=script&lang=js"
export * from "./producer_footer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59658f04",
  null
  
)

export default component.exports